export default "/images/d0fa32b7cca35b42ddcec8d092f22fce.png";